export default {
    routerName: '首页',
    card: {
        user: '用户数',
        ad: '广告数',
        article: '文章数',
        articleHits: '文章阅览量(前周)',
        picture: '图片数',
        pictureHits: '图片阅览量(前周)',
        tag:'标签',
        journal:'刊物',
    },
    adCount: '广告作成数分配',
    articleCreateCount: '文章作成数(前周)',
    adAccessFrom: '广告访问来源',
    userActiveDegree: '每周用户活跃量',
    region: {
        hokaido: '北海道',
        touhoku: '东北',
        kanntou: '关东',
        tyubu: '中部',
        kinki: '近畿',
        tyugoku: '中国',
        sikoku: '四国',
        kyuusyuu: '九州',
        okinawaken: '冲绳',
        kaigai: '海外',
    },
    log: {
        accessLog: '访问日志',
        operLog: '操作日志',
        normal: '正常',
        error: '异常',
        total: '总量',
    },
    date: {
        mon: '星期一',
        tue: '星期二',
        wed: '星期三',
        thu: '星期四',
        fri: '星期五',
        sat: '星期六',
        sun: '星期天',
    },
    systemInfo: {
        systemName: '系统名称',
        systemVersion: '版本信息',
        osName: '操作系统',
        osVersion: '系统版本',
        osArch: '系统架构',
        cpuCoreCount: 'CPU核数',
        memoryTotal: '系统内存',
        memoryFree: '剩余内存',
        memoryUsedPercent: '内存使用',
        localeLanguage: '系统语言',
        jvmName: 'JVM信息',
        jvmVersion: 'JVM版本',
        jvmHome: 'JAVA_HOME ',
        userDir: '工作目录  ',
        jvmTotalMemory: 'JVM占用内存',
        jvmFreeMemory: 'JVM空闲内存',
        jvmMaxMemory: 'JVM最大内存',
        userName: '当前用户',
        cpuCombinedPercent: 'CPU负载',
        zone: '系统时区',
    },
};
